import { useState, useCallback } from 'react';
import { searchMember } from '../../services/primeService';
import { ApiError } from '../../services/api';
import type { PrimeActor, PrimeMember } from '../../types/prime.types';

export interface UsePrimeSearch {
  search: (phone: string) => Promise<PrimeMember | null>;
  searching: boolean;
  notFound: boolean;
  error: string | null;
  result: PrimeMember | null;
  reset: () => void;
}

export function usePrimeSearch(actor: PrimeActor | null): UsePrimeSearch {
  const [searching, setSearching] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<PrimeMember | null>(null);

  const search = useCallback(async (phone: string): Promise<PrimeMember | null> => {
    if (!actor) { setError('Mangler medarbejder-kontekst.'); return null; }
    setSearching(true); setError(null); setNotFound(false); setResult(null);
    try {
      const r = await searchMember(phone);
      if (r.found && r.member) { setResult(r.member); return r.member; }
      setNotFound(true);
      return null;
    } catch (err) {
      setError(err instanceof ApiError ? err.message : (err instanceof Error ? err.message : 'Der opstod en fejl'));
      return null;
    } finally {
      setSearching(false);
    }
    // actor?.employeeId dækker aktør-skift; ApiError-import bruges til fejltype.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actor?.employeeId]);

  const reset = useCallback(() => { setNotFound(false); setError(null); setResult(null); }, []);

  return { search, searching, notFound, error, result, reset };
}
